<template>
  <div class="pay-fee-audit-manage-container">
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select v-model="searchForm.payObjType" placeholder="请选择付费对象"
            style="width:100%">
            <el-option v-for="item in payObjTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
        <!-- <el-col :span="6">
          <el-select v-model="searchForm.state" placeholder="请选择状态" style="width:100%">
            <el-option label="待审核" value="1010" />
            <el-option label="审核通过" value="2020" />
            <el-option label="审核未通过" value="3030" />
          </el-select>
        </el-col> -->
        <el-col :span="6">
          <el-input v-model="searchForm.payerObjId" :placeholder="searchForm.payObjType === '666'
            ? '请填写车牌号'
            : '请填写房屋 楼栋-单元-室'" />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button @click="handleReset">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>邻里豆返还比例</span>
        <el-button type="primary" size="small" style="float:right" @click="handleBatchAudit">
          <i class="el-icon-plus"></i>
          批量修改
        </el-button>
      </div>

      <el-table :data="tableData" border style="width:100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column prop="payerObjName" label="付费对象" align="center" />
        <el-table-column prop="feeName" label="费用项目" align="center" />
        <el-table-column prop="feeFlagName" label="费用标识" align="center" />
        <el-table-column prop="feeTypeCdName" label="费用类型" align="center" />
        <el-table-column prop="amountOwed" label="应收金额(单位:元)" align="center" />
        <el-table-column prop="returnLlBeanRate" label="返还比例" align="center">
          <template slot-scope="scope">
            {{ scope.row.returnLlBeanRate != null ? scope.row.returnLlBeanRate + '%' : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="returnLlBeanAmount" label="返还邻里豆数量" align="center">
          <template slot-scope="scope">
            {{ scope.row.returnLlBeanAmount != null ? scope.row.returnLlBeanAmount : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="建账时间" align="center" />
        <el-table-column label="应收周期" align="center">
          <template slot-scope="scope">
            {{ scope.row.endTime }}~<br />{{ scope.row.deadlineTime }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" align="center" />
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleAudit(scope.row)">
              修改返还比例
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <div class="tip-text">
          <!-- 缴费审核不会影响缴费入账，财务用来核对缴费是否正确 -->
        </div>
        <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
          :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <audit-modal ref="auditModal" @success="handleAuditSuccess" />
    <return-pay-fee-modal ref="returnPayFeeModal" @success="handleRefundSuccess" />
  </div>
</template>

<script>
import { listFee } from '@/api/fee/simplifyRoomFeeApi'
import { updateLlBean } from '@/api/fee/feeApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import AuditModal from '@/components/fee/audit'
import ReturnPayFeeModal from '@/components/fee/returnPayFee'

export default {
  name: 'PayFeeAuditManageList',
  components: {
    AuditModal,
    ReturnPayFeeModal
  },
  data() {
    return {
      searchForm: {
        communityId: '',
        payObjType: '',
        state: '1010',
        payerObjType: '3333',
        payerObjId:'752026020786755007',
        state: 2008001,
        payerObjId: ''
      },
      tableData: [],
      multipleSelection: [],
      payObjTypes: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      currentRow: null
    }
  },
  created() {
    this.searchForm.communityId = getCommunityId()
    this.getList()
    this.getPayObjTypes()
  },
  methods: {
    async getList() {
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        }
        const { fees, total } = await listFee(params)
        this.tableData = fees
        this.pagination.total = total
      } catch (error) {
        this.$message.error('获取费用数据失败')
      }
    },
    async getPayObjTypes() {
      try {
        this.payObjTypes = await getDict('pay_fee', 'payer_obj_type')
      } catch (error) {
        console.error('获取付费对象类型失败:', error)
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        communityId: getCommunityId(),
        payObjType: '',
        payerObjId: ''
      }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.current = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
 
    handleAudit(row) {
      this.currentRow = row
      this.$refs.auditModal.open({
        feeIds: row.feeId,
        communityId: this.searchForm.communityId,
        returnLlBeanRate: row.returnLlBeanRate || 0,
        payerObjName: row.payerObjName
      })
    },
    handleBatchAudit() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择费用')
        return
      }
      this.currentRow = null
      const feeIds = this.multipleSelection.map(item => item.feeId)
      const payerObjNames = this.multipleSelection.map(item => item.payerObjName)
      this.$refs.auditModal.open({
        feeIds: feeIds,
        communityId: this.searchForm.communityId,
        returnLlBeanRate: null,
        payerObjName: payerObjNames
      })
    },
    handleRefund(row) {
      this.$refs.returnPayFeeModal.open(row)
    },
    async handleAuditSuccess(data) {
      try {
        await updateLlBean({
          feeIds: data.feeIds,
          returnLlBeanRate: data.returnLlBeanRate
        })
        this.$message.success('操作成功')
        this.getList()
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    handleRefundSuccess() {
      this.getList()
    },
    getStatusTagType(state) {
      switch (state) {
        case '2020': return 'success'
        case '3030': return 'danger'
        default: return 'info'
      }
    },
    getStatusText(state) {
      switch (state) {
        case '2020': return '审核通过'
        case '3030': return '审核未通过'
        default: return '待审核'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-fee-audit-manage-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .tip-text {
      color: #999;
      font-size: 12px;
    }
  }
}
</style>